module.exports = __webpack_public_path__ + "assets/8208dab02fafa37981a3f7adf03c383d.mp3";